import { defineStore } from "pinia";
import type { RouterOutput } from "~/plugins/trpc";
type Advertiser = RouterOutput["advertiser"]["listAdvertisers"][number];

export const useNavigationStore = defineStore("navigation", () => {
  const initialActiveAdvertiser = localStorage.getItem("activeAdvertiser");

  const activeAdvertiser = ref<Advertiser | null>(
    initialActiveAdvertiser ? JSON.parse(initialActiveAdvertiser) : null,
  );

  watch(activeAdvertiser, () => {
    if (activeAdvertiser.value) {
      localStorage.setItem(
        "activeAdvertiser",
        JSON.stringify(activeAdvertiser.value),
      );
    } else {
      localStorage.removeItem("activeAdvertiser");
    }
  });

  const breadcrumbs = ref<{ name: string; link?: string }[]>([]);

  // for refreshing team management list after users were invited
  const lastInvitedUserId = ref<string | null>(null);

  return {
    activeAdvertiser,
    lastInvitedUserId,
    breadcrumbs,
  };
});
